
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';
    import { makeObject } from '@/components/editor/utils/editor';
    import { namespace } from 'nuxt-property-decorator';
    import { AvailableGroups, ComponentMeta } from '@/components/editor/config/types';
    import { getComponentMeta } from '@/store/editor';

    const editor = namespace('editor');

    @Component
    export default class ComponentsList extends Vue {
        @Prop() components;
        @Prop() indexAddComponent;
        @Prop() emitOnly;

        @editor.Mutation setComponentByIndex;
        @editor.Mutation addComponent;
        @editor.Mutation editComponent;

        currentGroup: any = null;
        currentGroupName: any = null;
        AvailableGroups = AvailableGroups;

        @Emit('addedComponent')
        add(val) {
            let meta: ComponentMeta = getComponentMeta(val);
            let options = makeObject(meta.options);

            if (this.emitOnly) {
                return {
                    componentName: val,
                    index: this.indexAddComponent,
                    options: options
                };
            }

            this.addComponent({
                componentName: val,
                index: this.indexAddComponent,
                options: options
            });
        }

        get baseComponents() {
            return this.components.filter(component => {
                return !component.inner;
            });
        }

        getPopoverImage(i) {
            return `<img src="/block-preview/${i}.jpg">`;
        }

        get groups() {
            let groups = {} as any;
            for (let i in this.components) {
                let component = this.components[i];
                let group =
                    component.group !== undefined
                        ? component.group
                        : AvailableGroups.Другое;
                if (!groups[group]) {
                    groups[group] = {};
                }
                groups[group][i] = component;
            }
            return groups;
        }

        @Emit('close')
        close() {
            return true;
        }

        showComponents(components, group) {
            this.currentGroup = components;
            this.currentGroupName = group;
        }
    }
